import HomeOutlineOne from '@assets/icons/home-outline-one.svg'
import { Icon } from './Icon'

export const HomeOutlineOneIcon = Icon(HomeOutlineOne)
